<script setup lang="ts">
interface Props {
  backgroundColor?: 'bg-dark' | 'bg-light' | 'bg-white';
}

withDefaults(defineProps<Props>(), {
  backgroundColor: 'bg-white',
});
</script>

<template>
  <div :class="['content-row-header', backgroundColor]">
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
.bg-dark {
  background-color: @color-background-dark;
}

.bg-light {
  background-color: @color-background-light;
}

.bg-white {
  background-color: white;
}

.content-row-header {
  text-align: center;
  width: 100%;
  color: @color-primary;
  padding: 0.29rem 0;
  font-size: 1rem;
}
</style>
